export default "__VITE_ASSET__DHeu5lAx__"